export default __webpack_public_path__ + "static/media/jwelerybox.b79eea99.png";